import initMaterialize from './materialize';

export default () => {
  initMaterialize();
};
